module.exports = __webpack_public_path__ + "static/media/person-4.3e08d7c1.png";